import Dialog, { DialogContent } from '@/components/Dialog';
import { SHARE_MODAL_TYPES } from '@/store/editor';

import PrintDocumentContent from './PrintDocumentContent';
import ShareCopyLink from './ShareCopyLink';
import ShareSendByEmail from './ShareSendByEmail';

function ShareDocumentModal({
	defaultFileName,
	id,
	open,
	onOpenChange,
	type,
	publicId
}) {
	const content = (
		<>
			{type === SHARE_MODAL_TYPES.COPY_LINK && (
				<ShareCopyLink id={publicId} onOpenChange={onOpenChange} />
			)}
			{type === SHARE_MODAL_TYPES.PRINT && (
				<PrintDocumentContent id={id} onOpenChange={onOpenChange} />
			)}
			{type === SHARE_MODAL_TYPES.SEND_BY_EMAIL && (
				<ShareSendByEmail
					defaultFileName={defaultFileName}
					id={id}
					onOpenChange={onOpenChange}
					open={open}
				/>
			)}
		</>
	);

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="w-[280px] md:w-[397px]">
				{content}
			</DialogContent>
		</Dialog>
	);
}

export default ShareDocumentModal;
